import { useSelector } from 'react-redux';
import { DEMO_USER_EMAIL } from 'constants/emails';
import { currentUserEmailSelector } from 'store/slices/userDetailsSlice';

export const useIsDemoUser = (isStrictEmail) => {
  const email = useSelector(currentUserEmailSelector);
  const isDemoEmail = email === DEMO_USER_EMAIL;

  return isStrictEmail ? isDemoEmail : !email || isDemoEmail;
};
